import src from "IMAGE";
export default { src, width: 36, height: 32, blurWidth: 0, blurHeight: 0};
